<template>
  <div>
    <a-modal v-model="visible" title="Edit Facility" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update</a-button>
      </template>
      <a-form class="mb-4" :form="form">
        <div class="row">
          <div class="col-12">
            <a-form-item label="Facility Name">
              <a-input
                placeholder="Facility Name"
                v-decorator="['name', {rules: [{ required: true, message: 'Please input a facility name!' }]}]"
              />
            </a-form-item>
          </div>

<!--          <div class="col-12 col-md-6">-->
<!--            <a-form-item label="Status">-->
<!--              <a-select v-decorator="['status', { rules: [{ required: false, message: 'Facility status is required!!' }] } ]" placeholder="Facility Status">-->
<!--                <a-select-option v-for="facilityStatus in facilitiesStatus" :value="facilityStatus.value" :key="facilityStatus.value">-->
<!--                  {{ facilityStatus.name }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
<!--          </div>-->
        </div>

<!--        <div class="row">-->
<!--          <div class="col-12">-->
<!--            <a-form-item label="Quantity">-->
<!--              <a-input-number-->
<!--                :min="1"-->
<!--                v-decorator="['quantity',{initialValue: '1'}, {rules: [{ required: true, message: 'Please input quantity!'}]}]"-->
<!--                style="width: 100%"-->
<!--              />-->
<!--            </a-form-item>-->
<!--          </div>-->
<!--        </div>-->

        <div class="mb-2">
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description']" />
          </a-form-item>
        </div>

        <div class="mb-2">
          <a-form-item label="Usage Restrictions">
            <a-textarea placeholder="Usage Restrictions" :autosize="{minRows: 2}" v-decorator="['usage_restrictions']" />
          </a-form-item>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { facilitiesStatus } from '@/services/globaldata'
export default {
  name: 'editFacility',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      facilitiesStatus,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openEditForm', this.showForm)
  },
  methods: {
    moment,
    showForm: function(record) {
      this.visible = true
      this.oldrecord = record
      setTimeout(() => {
        this.form.setFieldsValue({
          'name': record.name,
          // 'quantity': record.quantity,
          'description': record.description,
          // 'status': record.status,
          'usage_restrictions': record.usage_restrictions,
        })
      }, 50)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$http
            .patch(`/api/hostel/facility/${this.oldrecord.id}`, {
              name: values.name,
              // quantity: values.quantity,
              description: values.description,
              // status: values.status,
              usage_restrictions: values.usage_restrictions,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.form.resetFields()
                this.$notification['success']({
                  message: 'Successfully edited',
                  description: 'Facility edited successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
  },
}
</script>
